import React, { useCallback, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import "../Styles/CardPartido.css";
import { ModalUtil } from "../../ModalUtil/Components/ModalUtilComponent";

import axios from "axios";
import { BASE_URL } from "../../../config";
import { useParams } from "react-router-dom";
import { EstadisticasPartidoComponentLogout } from "./EstadisticasPartidoComponentLogout";

const CardPartidosLogout = () => {
  const { idTorneo } = useParams();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPartidoId, setSelectedPartidoId] = useState(null);
  const [selectedEquipoId, setSelectedEquipoId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 6;
  const [showModalEstadisticas, setShowModalEstadisticas] = useState(false);
  const [partidos, setPartidos] = useState([]);


  const handleCloseModalEstadisticas = () => {
    setShowModalEstadisticas(false);
  };

  const obtenerPartidos = useCallback(async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}get-partidos-torneo/${idTorneo}`
      );
      const partidosConDetalles = response.data.map((partido) => ({
        id: partido.id,
        equipo1: partido.equipo_a.nombre,
        equipo2: partido.equipo_b.nombre,
        estado: partido.estado,
        marcador: `${partido.puntosEquipoA} - ${partido.puntosEquipoB}`,
        arbitro1: partido.arbitro1
          ? `${partido.arbitro1.nombres} ${partido.arbitro1.apellidos}`
          : "No disponible",
        arbitro2: partido.arbitro2
          ? `${partido.arbitro2.nombres} ${partido.arbitro2.apellidos}`
          : "No disponible",
        escenario: partido?.escenario?.nombreEscenario,
        fecha: partido.fechaPartido,
        hora: partido.horaInicial,
        idEquipo1: partido.idEquipoA,
        idEquipo2: partido.idEquipoB,
        imagenEquipo1: partido.equipo_a.urlImagen,
        imagenEquipo2: partido.equipo_b.urlImagen,
      }));
      setPartidos(partidosConDetalles);
    } catch (error) {
      console.error(error);
    }
  }, [idTorneo]);

  useEffect(() => {
   

    obtenerPartidos();
  }, [obtenerPartidos, idTorneo]);



  const filteredPartidos = partidos.filter(
    (partido) =>
      partido?.equipo1?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      partido?.equipo2?.toLowerCase().includes(searchTerm.toLowerCase()) ||
 
     partido?.estado?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

 
  const handleEstadisticas = (idPartido, idEquipo) => {
    setSelectedPartidoId(idPartido);
    setSelectedEquipoId(idEquipo);
    setShowModalEstadisticas(true);
  };

 

  const displayPartidos = filteredPartidos
    .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage)
    .map((partido) => (
      <div key={partido.id} className="partido-card">
        <div className="equipo-section">
          <div className="equipo">
            <img
              src={partido.imagenEquipo1}
              alt={partido.equipo1}
              className="equipo-logo"
            />
            <p className="equipo-nombre">{partido.equipo1}</p>
            <div className="button-container">
              <i
                className="fas fa-chart-bar fa-2x icon-button"
                title="Estadísticas"
                onClick={() =>
                  handleEstadisticas(partido.id, partido.idEquipo1)
                }
              ></i>
            </div>
          </div>

          <span className="vs-text">VS</span>

          <div className="equipo">
            <img
              src={partido.imagenEquipo2}
              alt={partido.equipo2}
              className="equipo-logo"
            />
            <p className="equipo-nombre">{partido.equipo2}</p>
            <div className="button-container">
              <i
                className="fas fa-chart-bar fa-2x icon-button"
                title="Estadísticas"
                onClick={() =>
                  handleEstadisticas(partido.id, partido.idEquipo2)
                }
              ></i>
            </div>
          </div>
        </div>

        <div
          className={`estado-partido estado-${partido.estado.toLowerCase()}`}
        >
          <p>{partido.estado}</p>
        </div>


        <div>
          <p>{partido.fecha}</p>
        </div>

        <div>
          <p>{partido.hora}</p>
        </div>

        <div className="marcador-partido">
          <p>{partido.marcador}</p>
        </div>

      </div>
    ));

  return (
    <div className="partidos-container">
      <input
        type="text"
        placeholder="Buscar partidos..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
      />
      <div className="card-container">{displayPartidos}</div>
      <ReactPaginate
        pageCount={Math.ceil(filteredPartidos.length / itemsPerPage)}
        onPageChange={handlePageClick}
        containerClassName="pagination"
        activeClassName="active"
        previousLabel={"< Anterior"}
        nextLabel={"Siguiente >"}
      />

    

      <ModalUtil
        show={showModalEstadisticas}
        handleClose={handleCloseModalEstadisticas}
        titulo={"Estadísticas Partido"}
        size="lg"
      >
        <EstadisticasPartidoComponentLogout
          idPartido={selectedPartidoId}
          idEquipo={selectedEquipoId}
        />
      </ModalUtil>

     
    </div>
  );
};

export { CardPartidosLogout };
